import Box from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import MainNavigationItem from "./MainNavigationItem";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import WorkIcon from "@mui/icons-material/Work";
import SendIcon from "@mui/icons-material/Send";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import GroupIcon from "@mui/icons-material/Group";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import { canAccess } from "services/Permissions.service";
import { PERMISSION_KEYS } from "constants/roles";
import { useSelector } from "react-redux";

const navigationItems = [
    {
        to: "/",
        text: "Candidates",
        icon: <LocalFireDepartmentOutlinedIcon />,
        activeIcon: <LocalFireDepartmentIcon />,
        permissionKey: PERMISSION_KEYS.CANDIDATE_VIEW_LIST,
    },
    {
        to: "/companies",
        text: "Companies",
        icon: <WorkOutlineIcon />,
        activeIcon: <WorkIcon />,
        permissionKey: PERMISSION_KEYS.COMPANY_VIEW_LIST,
    },
    {
        to: "/requests",
        text: "Linq requests",
        icon: <SendOutlinedIcon />,
        activeIcon: <SendIcon />,
        permissionKey: PERMISSION_KEYS.LINQ_REQUEST_VIEW_LIST,
    },
    {
        to: "/external-recruiters-management",
        text: "External Recruiters",
        icon: <GroupOutlinedIcon />,
        activeIcon: <GroupIcon />,
        permissionKey: PERMISSION_KEYS.EXTERNAL_RECRUITER_VIEW_MANAGEMENT,
    },
];

export default function MainNavigation({ isSidebarOpen }) {
    const roleId = useSelector((state) => state.userValues.user?.role.id);

    return (
        <Box sx={{ padding: "10px", paddingTop: "30px" }}>
            <MenuList>
                {navigationItems.map((item) => {
                    const canView = canAccess(item.permissionKey, roleId);
                    if (!canView) return null;

                    return (
                        <MainNavigationItem
                            key={item.to}
                            to={item.to}
                            text={item.text}
                            icon={item.icon}
                            activeIcon={item.activeIcon}
                            isSidebarOpen={isSidebarOpen}
                        />
                    );
                })}
            </MenuList>
        </Box>
    );
}
